export enum SessionStatus {
    UNMARKED = 'UNMARKED',
    PRESENT = 'PRESENT',
    ABSENT = 'ABSENT',
}

export const SESSION_STATUS_CONFIG = {
    [SessionStatus.UNMARKED]: {
        label: 'Chưa đánh dấu',
        cssClass: 'text-sm !bg-gray-100 !text-gray-700'
    },
    [SessionStatus.PRESENT]: {
        label: 'Có mặt',
        cssClass: 'text-sm !bg-green-100 !text-green-700'
    },
    [SessionStatus.ABSENT]: {
        label: 'Vắng mặt',
        cssClass: 'text-sm !bg-red-100 !text-red-700'
    }
};

export const SESSION_STATUS_OPTIONS = Object.entries(SESSION_STATUS_CONFIG).map(([key, value]) => ({
    label: value.label,
    value: key,
    cssClass: value.cssClass
}));

